import SideBar from "../../components/AdminDashboard/SideBar";
import "../../styles/AdminDashboard/Settings.scss";
import ProfileImg from "../../images/Ellipse 57.png";
import {
  Box,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Modal,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import Resizer from "react-image-file-resizer";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useEffect, useRef, useState } from "react";
import { deactivateUser, getUserInfo, updateAdminInfo, updatePassword } from "../../apis/General/users";
import { useDispatch, useSelector } from "react-redux";
import { deleteAdmin, getAdmins } from "../../apis/AdminDashboard/users";
import { toast } from "react-toastify";
import { Await, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Search from "../../components/AdminDashboard/Search";
import { link } from "fs";
import { createAdmin } from "../../apis/AdminDashboard/authentication";
const AddAdmin = ({onCancel,onSave,}) => {
  const auth = useSelector((state) => state.auth);  

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [tab, setTab] = useState("account");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [uplaodLoading, setUploadLoading] = useState(false);
  const [images, setImages] = useState([]);

  const [admins, setAdmins] = useState([]);
  const mediaRef = useRef(null);

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
const [adminSuccess, setAdminSuccess] = useState(false)
    const handleOpen = () => setAdminSuccess(true);
    const handleClose = () => setAdminSuccess(false);
  const options = [
    "Dashboard",
    "CCRT",
    "Voluntary Donation",
    "IOT Devices",
    "NDC’s",
    "User",
    "KYC Validation",
    "History",
    "validators",
    "Settings",
    "scheduling",
    "Request",
    "Account",

  ];

  const toggleOption = (option) => {
    setSelected((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option) // remove
        : [...prev, option] // add
    );
  };
  useEffect(() => {
  setForm((prev) => ({ ...prev, permissions: selected }));
}, [selected]);

  console.log("Selected", selected)
  const permissions = selected
 const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    department: "",
    selected:"",
    auth

  });
  console.log("admin", form)

  const handleChange = (e) =>
    setForm((s) => ({ ...s, [e.target.name]: e.target.value }));

  const handleSubmit =  async (e) => {
    e.preventDefault();
    const createAdminResponse = await createAdmin(form,auth?.token)
    toast.success("Admin created successfully")
    handleOpen()
    console.log("admin response  ", createAdminResponse)
    if (onSave) onSave(form);
    
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const fetchUserInfo = async () => {
    setLoading(true)
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    // console.log('userDetails', response);
    setFirstName(response?.data?.message?.firstName);
    setLastName(response?.data?.message?.lastName);
    setEmail(response?.data?.message?.email);
    setLoading(false)

    
  };

  const fetchAdmins = async () => {
    const response = await getAdmins(auth?.token);
    console.log('getAdmins', response);
    setAdmins(response?.data?.message)
  }

  useEffect(() => {
    fetchUserInfo();
    fetchAdmins()
  }, []);

  const handleUpdatePassword = async(e) => {
    setLoading(true)
    e.preventDefault();
    if(newPassword === newPasswordConfirm) {
      const response = await updatePassword(oldPassword, newPassword, auth?.token);
    // console.log('response', response);
    if(response?.data?.statusCode === 200) {
      toast.success('Password updated successfully')
      setOldPassword("")
    setNewPassword("")
    setNewPasswordConfirm("")
    } else {
      toast.error(response?.data?.message)
    }
    
    } else {
      alert('Passwords do not match')
    }
    setLoading(false)

  }

  const handleDeleteUser = async () => {
    setLoading(true)
    const response = await deactivateUser(auth?.userInfo?.id, auth?.token);
    // console.log('response', response);
    if(response?.data?.statusCode === 200) {
      toast.success(response?.data?.message)
      dispatch({
        type: "LOGOUT_SUCCESS",
      });
      localStorage.removeItem("token");
      navigate("/login");
      window.scrollTo(0, 0);
    }else {
      toast.error(response?.data?.message)

    }
    setLoading(false)
  }

  const handleRemoveAdmin = async (id) => {
    setLoading(true);
    // console.log('id', id);
    const response = await deleteAdmin(id, auth?.token);
    console.log('response', response);
    if(response?.data?.statusCode === 200) {
      toast.success(response?.data?.message)
    }else {
      toast.error(response?.data?.message)

    }
    // console.log('response', response);
    setLoading(false)
  }
  const handleUpdateAdmin = async (e) => {
    setLoading(true);
    e.preventDefault()
    const response = await updateAdminInfo(firstName, lastName, email, "", auth?.token)
    if(response?.data?.statusCode === 200) {
      toast.success(response?.data?.message)
    }else {
      toast.error(response?.data?.message)

    }
    // console.log('response', response);
    setLoading(false)
  }

  const fileUpload = (e) => {
    setUploadLoading(true);

    let files = e.target.files;
    let allUploadedFiles = images;

    const fileToUri = (file, cb) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(null, reader.result);
      };
      reader.onerror = function (error) {
        cb(error, null);
      };
    };

    if (files) {
      for (let i = 0; i < files.length; i++) {
        fileToUri(files[0], (err, result) => {
          if (result) {
            // console.log('mourinho', result);
            axios
              .post(
                `${process.env.REACT_APP_API_URL}/open/v1/upload`,
                {
                  media_type: "image",
                  folder: "documents",
                  user_id: auth?.userInfo?.id,
                  contents: [result],
                },
                {
                  headers: {
                    Authorization: `Bearer ${auth ? auth.token : ""}`,
                  },
                }
              )
              .then((response) => {
                console.log('wenger', response);
                // if (response?.data?.body?.success === true) {
                //   if (documentTypeSent === "organizationBoundary") {
                //     setOrganizationBoundary(response?.data?.body?.data[0]);
                //   } else if (documentTypeSent === "reportingBoundary") {
                //     setReportingBoundary(response?.data?.body?.data[0]);
                //   } else if (documentTypeSent === "historicalInventory") {
                //     setHistoricalInventory(response?.data?.body?.data[0]);
                //   } else if (documentTypeSent === "typeofFuel") {
                //     setTypeofFuel(response?.data?.body?.data[0]);
                //   } else if (
                //     documentTypeSent === "descriptionOfRenewableEnergySources"
                //   ) {
                //     setDescriptionOfRenewableEnergySources(
                //       response?.data?.body?.data[0]
                //     );
                //   } else if (documentTypeSent === "projectMonitoringReport") {
                //     setProjectMonitoringReport(response?.data?.body?.data[0]);
                //   } else if (documentTypeSent === "projectDescriptionReport") {
                //     setProjectDescriptionReport(response?.data?.body?.data[0]);
                //   } else {
                //     toast.error("document type not specified");
                //   }
                // }
                setUploadLoading(false);
              })
              .catch((err) => {
                setUploadLoading(false);
              });
          }
        });
      }
    }
  };


    const cards = [
    {
      icon: <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.9974 2.66797C8.6334 2.66797 2.66406 8.6373 2.66406 16.0013C2.66406 23.3653 8.6334 29.3346 15.9974 29.3346C23.3614 29.3346 29.3307 23.3653 29.3307 16.0013C29.3307 8.6373 23.3614 2.66797 15.9974 2.66797Z" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.69531 24.4613C5.69531 24.4613 8.66731 20.6667 16.0006 20.6667C23.334 20.6667 26.3073 24.4613 26.3073 24.4613M16.0006 16C17.0615 16 18.0789 15.5786 18.8291 14.8284C19.5792 14.0783 20.0006 13.0609 20.0006 12C20.0006 10.9391 19.5792 9.92172 18.8291 9.17157C18.0789 8.42143 17.0615 8 16.0006 8C14.9398 8 13.9224 8.42143 13.1722 9.17157C12.4221 9.92172 12.0006 10.9391 12.0006 12C12.0006 13.0609 12.4221 14.0783 13.1722 14.8284C13.9224 15.5786 14.9398 16 16.0006 16Z" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
,
      title: "Profile",
      description: "Update your personal details and picture",
      border: "border-[#E5E5E5]",
      Links: "/admin/admin-profile",
      bg: "bg-[#FAFAFA]",

      // bg: "bg-white",
    },
    {
      icon:<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.0026 22.6654C15.2954 22.6654 14.6171 22.3844 14.117 21.8843C13.6169 21.3842 13.3359 20.7059 13.3359 19.9987C13.3359 18.5187 14.5226 17.332 16.0026 17.332C16.7098 17.332 17.3881 17.613 17.8882 18.1131C18.3883 18.6132 18.6693 19.2915 18.6693 19.9987C18.6693 20.7059 18.3883 21.3842 17.8882 21.8843C17.3881 22.3844 16.7098 22.6654 16.0026 22.6654ZM24.0026 26.6654V13.332H8.0026V26.6654H24.0026ZM24.0026 10.6654C24.7098 10.6654 25.3881 10.9463 25.8882 11.4464C26.3883 11.9465 26.6693 12.6248 26.6693 13.332V26.6654C26.6693 27.3726 26.3883 28.0509 25.8882 28.551C25.3881 29.0511 24.7098 29.332 24.0026 29.332H8.0026C7.29536 29.332 6.61708 29.0511 6.11699 28.551C5.61689 28.0509 5.33594 27.3726 5.33594 26.6654V13.332C5.33594 11.852 6.5226 10.6654 8.0026 10.6654H9.33594V7.9987C9.33594 6.23059 10.0383 4.5349 11.2886 3.28465C12.5388 2.03441 14.2345 1.33203 16.0026 1.33203C16.8781 1.33203 17.745 1.50447 18.5538 1.8395C19.3627 2.17453 20.0976 2.6656 20.7167 3.28465C21.3357 3.90371 21.8268 4.63864 22.1618 5.44747C22.4968 6.25631 22.6693 7.12322 22.6693 7.9987V10.6654H24.0026ZM16.0026 3.9987C14.9417 3.9987 13.9243 4.42013 13.1742 5.17027C12.424 5.92042 12.0026 6.93783 12.0026 7.9987V10.6654H20.0026V7.9987C20.0026 6.93783 19.5812 5.92042 18.831 5.17027C18.0809 4.42013 17.0635 3.9987 16.0026 3.9987Z" fill="#101828" stroke="white" stroke-width="0.5"/>
</svg>
,
      title: "Password & Security",
      description: "See your password and update your password",
      border: "border-[#E5E5E5]",
      Links: "/admin/admin-password-and-security",
      bg: "bg-[#FAFAFA]",

      // bg: "bg-white",
    },
    {
      icon: <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 5C15.4696 5 14.9609 5.21071 14.5858 5.58579C14.2107 5.96086 14 6.46957 14 7C14 7.53043 14.2107 8.03914 14.5858 8.41421C14.9609 8.78929 15.4696 9 16 9C16.5304 9 17.0391 8.78929 17.4142 8.41421C17.7893 8.03914 18 7.53043 18 7C18 6.46957 17.7893 5.96086 17.4142 5.58579C17.0391 5.21071 16.5304 5 16 5ZM12 7C12 5.93913 12.4214 4.92172 13.1716 4.17157C13.9217 3.42143 14.9391 3 16 3C17.0609 3 18.0783 3.42143 18.8284 4.17157C19.5786 4.92172 20 5.93913 20 7C20 8.06087 19.5786 9.07828 18.8284 9.82843C18.0783 10.5786 17.0609 11 16 11C14.9391 11 13.9217 10.5786 13.1716 9.82843C12.4214 9.07828 12 8.06087 12 7ZM25.5 6C25.1022 6 24.7206 6.15804 24.4393 6.43934C24.158 6.72064 24 7.10218 24 7.5C24 7.89782 24.158 8.27936 24.4393 8.56066C24.7206 8.84196 25.1022 9 25.5 9C25.8978 9 26.2794 8.84196 26.5607 8.56066C26.842 8.27936 27 7.89782 27 7.5C27 7.10218 26.842 6.72064 26.5607 6.43934C26.2794 6.15804 25.8978 6 25.5 6ZM22 7.5C22 7.04037 22.0905 6.58525 22.2664 6.16061C22.4423 5.73597 22.7001 5.35013 23.0251 5.02513C23.3501 4.70012 23.736 4.44231 24.1606 4.26642C24.5852 4.09053 25.0404 4 25.5 4C25.9596 4 26.4148 4.09053 26.8394 4.26642C27.264 4.44231 27.6499 4.70012 27.9749 5.02513C28.2999 5.35013 28.5577 5.73597 28.7336 6.16061C28.9095 6.58525 29 7.04037 29 7.5C29 8.42826 28.6313 9.3185 27.9749 9.97487C27.3185 10.6313 26.4283 11 25.5 11C24.5717 11 23.6815 10.6313 23.0251 9.97487C22.3687 9.3185 22 8.42826 22 7.5ZM5 7.5C5 7.10218 5.15804 6.72064 5.43934 6.43934C5.72064 6.15804 6.10218 6 6.5 6C6.89782 6 7.27936 6.15804 7.56066 6.43934C7.84196 6.72064 8 7.10218 8 7.5C8 7.89782 7.84196 8.27936 7.56066 8.56066C7.27936 8.84196 6.89782 9 6.5 9C6.10218 9 5.72064 8.84196 5.43934 8.56066C5.15804 8.27936 5 7.89782 5 7.5ZM6.5 4C5.57174 4 4.6815 4.36875 4.02513 5.02513C3.36875 5.6815 3 6.57174 3 7.5C3 8.42826 3.36875 9.3185 4.02513 9.97487C4.6815 10.6313 5.57174 11 6.5 11C7.42826 11 8.3185 10.6313 8.97487 9.97487C9.63125 9.3185 10 8.42826 10 7.5C10 6.57174 9.63125 5.6815 8.97487 5.02513C8.3185 4.36875 7.42826 4 6.5 4ZM8.651 24.505C8.19873 24.8031 7.67418 24.9732 7.13304 24.9972C6.59189 25.0212 6.05434 24.8983 5.57743 24.6414C5.10052 24.3846 4.70206 24.0034 4.42433 23.5383C4.1466 23.0733 3.99997 22.5417 4 22V15.5C4 15.3674 4.05268 15.2402 4.14645 15.1464C4.24022 15.0527 4.36739 15 4.5 15H8.531C8.62318 14.2681 8.91597 13.5759 9.377 13H4.5C3.83696 13 3.20107 13.2634 2.73223 13.7322C2.26339 14.2011 2 14.837 2 15.5V22C1.99974 22.8611 2.22186 23.7076 2.64484 24.4576C3.06782 25.2076 3.67732 25.8357 4.41431 26.281C5.15129 26.7263 5.99079 26.9737 6.85148 26.9993C7.71216 27.0249 8.56487 26.8277 9.327 26.427C9.01529 25.8201 8.78786 25.1734 8.651 24.505ZM22.673 26.427C23.4351 26.8277 24.2878 27.0249 25.1485 26.9993C26.0092 26.9737 26.8487 26.7263 27.5857 26.281C28.3227 25.8357 28.9322 25.2076 29.3552 24.4576C29.7781 23.7076 30.0003 22.8611 30 22V15.5C30 14.837 29.7366 14.2011 29.2678 13.7322C28.7989 13.2634 28.163 13 27.5 13H22.623C23.084 13.5759 23.3768 14.2681 23.469 15H27.5C27.6326 15 27.7598 15.0527 27.8536 15.1464C27.9473 15.2402 28 15.3674 28 15.5V22C28 22.5417 27.8534 23.0733 27.5757 23.5383C27.2979 24.0034 26.8995 24.3846 26.4226 24.6414C25.9457 24.8983 25.4081 25.0212 24.867 24.9972C24.3258 24.9732 23.8013 24.8031 23.349 24.505C23.2121 25.1734 22.9847 25.8201 22.673 26.427ZM12.5 13C11.837 13 11.2011 13.2634 10.7322 13.7322C10.2634 14.2011 10 14.837 10 15.5V23C10 24.5913 10.6321 26.1174 11.7574 27.2426C12.8826 28.3679 14.4087 29 16 29C17.5913 29 19.1174 28.3679 20.2426 27.2426C21.3679 26.1174 22 24.5913 22 23V15.5C22 14.837 21.7366 14.2011 21.2678 13.7322C20.7989 13.2634 20.163 13 19.5 13H12.5ZM12 15.5C12 15.3674 12.0527 15.2402 12.1464 15.1464C12.2402 15.0527 12.3674 15 12.5 15H19.5C19.6326 15 19.7598 15.0527 19.8536 15.1464C19.9473 15.2402 20 15.3674 20 15.5V23C20 24.0609 19.5786 25.0783 18.8284 25.8284C18.0783 26.5786 17.0609 27 16 27C14.9391 27 13.9217 26.5786 13.1716 25.8284C12.4214 25.0783 12 24.0609 12 23V15.5Z" fill="#101828"/>
</svg>
,
      title: "Team Access",
      description:
        "Control team accounts, assign roles, update details, and manage access securely.",
      border: "border-[#2C9963]",
      Links:"/admin/account-management-settings",

      bg: "bg-[#FAFAFA]",
    },
  ];

  return (
    <div className="admin_settings">
       <div className="sidebar_container">
        <SideBar />
      </div>


      <div className="main">
        <Search />
        {/* top bar */}
         <div className="absolute left-[218px] top-[78px] w-[1134px] flex flex-col gap-[30px]">
      {/* Header */}
     
    </div>

     <h2 className="text-[24px] font-semibold leading-[29px] text-[#101828] mb-8 mt-20">
        Settings
      </h2>

      {/* Cards Container */}
      <div className="flex gap-[33px]">
        {cards.map((card, idx) => (
        <div key={idx}>

        <Link to={card.Links}>
          <div
            className={"relative w-[356px] h-[167px]  border ${card.border} rounded-[12px] p-6"}
          >
            
            {/* Icon */}
            <div className="absolute top-6 left-6">{card.icon}</div>

            {/* Text Content */}
            <div className="absolute left-6 top-[72px] flex flex-col gap-2 w-[314px]">
              <h3 className="text-[24px] font-medium leading-[29px] text-[#101828]">
                {card.title}
              </h3>
              <p className="text-[14px] leading-[17px] text-[#98A2B3]">
                {card.description}
              </p>
            </div>

          </div>
            </Link>
</div>
        ))}
      </div>

 <div
      className="max-w-[1134px] w-full h-[786px] rounded-[24px] border border-[#667185] p-9 relative bg-white mt-10"
      role="region"
      aria-label="Add Admin"
    >
      {/* Back row */}
      <div className="flex items-center gap-3 absolute left-9 top-9">
        <svg
          width="8"
          height="16"
          viewBox="0 0 8 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="block"
          aria-hidden
        >
          <path d="M7 1L1 8L7 15" stroke="#101828" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <button
          type="button"
          onClick={onCancel}
          className="text-[12px] font-semibold text-[#101828]"
        >
          Go Back
        </button>
      </div>

      {/* Title */}
      <h2 className="text-[24px] font-semibold text-[#000000] absolute left-9 top-20">
        Add an Admin
      </h2>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="absolute left-9 top-40 w-[1028px] flex flex-col gap-12"
      >
        {/* Row 1: First & Last */}
        <div className="flex gap-6">
          <div className="flex-1">
            <label className="block text-[16px] text-[#101828] mb-3">First name</label>
            <input
            required
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              className="w-full h-[55px] rounded-md border-[0.5px] border-[#667185] px-4 text-[16px] placeholder:opacity-60"
              placeholder="Enter first name"
              aria-label="First name"
            />
          </div>

          <div className="flex-1">
            <label className="block text-[16px] text-[#101828] mb-3">Last name</label>
            <input
            required
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              className="w-full h-[55px] rounded-md border-[0.5px] border-[#667185] px-4 text-[16px] placeholder:opacity-60"
              placeholder="Enter last name"
              aria-label="Last name"
            />
          </div>
        </div>

        {/* Row 2: Email & Role */}
        <div className="flex gap-6">
          <div className="flex-1">
            <label className="block text-[16px] text-[#101828] mb-3">Email address</label>
            <input
            required
              name="email"
              value={form.email}
              onChange={handleChange}
              className="w-full h-[55px] rounded-md border-[0.5px] border-[#667185] px-4 text-[16px] placeholder:opacity-60"
              placeholder="you@company.com"
              type="email"
              aria-label="Email address"
            />
          </div>

          <div className="flex-1">
            <label className="block text-[16px] text-[#101828] mb-3">Role</label>
            <div className="relative">
              <select
              required
                name="role"
                value={form.role}
                onChange={handleChange}
                className="appearance-none w-full h-[55px] rounded-md border-[0.5px] border-[#667185] px-4 pr-10 text-[16px]"
                aria-label="Select role"
              >
                <option value="">Select a role</option>
                <option value="superAdmin"> Super Admin</option>
                <option value="admin"> Admin</option>
                <option value="validator">validator</option>
                <option value="RO">RO</option>
              </select>

              <svg
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden
              >
                <path d="M6 9l6 6 6-6" stroke="#667185" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Row 3: Department (full width) */}
        <div>
          <label className="block text-[16px] text-[#101828] mb-3">Department (Optional)</label>
          <input
            name="department"
            value={form.department}
            onChange={handleChange}
            className="w-full h-[55px] rounded-md border-[0.5px] border-[#667185] px-4 text-[16px] placeholder:opacity-60"
            placeholder="e.g. Marketing"
            aria-label="Department"
            
          />
        </div>


        {/* Spacer to simulate the big design gap */}
        <div className="flex-1 mb-20"  />

        {/* Actions */}
        <div className="flex items-center gap-4 justify-end mt-20 absolute right-9 bottom-9 ">
          <button
            type="button"
            onClick={onCancel}
            className="w-[175px] h-[52px] rounded-md border border-[#667185] flex items-center justify-center text-[14px] font-medium text-[#667185]"
          >
            Cancel
          </button>

          <button
            type="submit"
            className="w-[228px] h-[52px] rounded-md flex items-center justify-center text-[14px] font-medium text-white"
            style={{
              background: "linear-gradient(127.56deg, #038B47 0%, #00AED9 100%)",
            }}
          >
            Save As Admin
          </button>
        </div>
        
      </form>
    </div>

{
  adminSuccess && (
    <div onClick={handleClose} className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-20">

       <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-50">
      {/* Card */}
      <div className="relative w-[627px] h-[385px] bg-white border border-[#E5E5E5] rounded-xl flex flex-col items-center justify-center gap-8 p-8">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-8 right-8 text-gray-500 hover:text-gray-700"
        >
          <div className="w-6 h-6" />
        </button>

        {/* Illustration */}
        <div className="relative w-40 h-40 flex items-center justify-center">
          <div className="absolute w-36 h-36 rounded-full bg-[#038B47]/10" />
          {/* <span className="text-green-600 text-6xl">👍</span> */}
          <svg width="167" height="150" viewBox="0 0 167 150" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.05" cx="87.1744" cy="80.651" r="69.3463" fill="#038B47"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M87.4837 55.1863C89.1713 71.6433 79.4987 78.5069 76.7578 80.1039C76.7805 80.2738 76.7918 80.455 76.7918 80.6363V104.115L81.2996 106.596H105.005C105.051 106.596 105.107 106.596 105.153 106.607C110.612 107.355 110.827 100.899 110.827 100.095C110.793 99.6869 111.019 99.2791 111.416 99.1092C114.836 97.6368 113.387 93.0158 113.251 92.6193C113.07 92.155 113.285 91.6226 113.738 91.3961C118.178 89.2441 115.38 85.3706 115.018 84.8836C114.723 84.5664 114.678 84.0794 114.916 83.6943C122.957 71.3601 97.8358 74.4069 96.2275 74.6107C96.1029 74.6334 95.967 74.6447 95.8311 74.6107C95.2988 74.5088 94.959 73.9991 95.0609 73.4668C98.8099 54.4728 90.168 54.6767 87.461 55.1637L87.4837 55.1863Z" fill="#038B47"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M75.1807 104.399V80.6364C75.1807 80.0701 74.9542 79.5604 74.5804 79.1979C74.2067 78.8242 73.697 78.5977 73.142 78.5977H60.57C60.0037 78.5977 59.494 78.8242 59.1315 79.1979C58.7578 79.5717 58.5312 80.0814 58.5312 80.6364V104.399C58.5312 104.965 58.7578 105.475 59.1315 105.837C59.5053 106.211 60.015 106.437 60.57 106.437H73.142C73.7083 106.437 74.218 106.211 74.5804 105.837C74.8862 105.531 75.0901 105.135 75.1581 104.693C75.1581 104.625 75.1581 104.546 75.1807 104.478C75.1807 104.455 75.1807 104.421 75.1807 104.399Z" fill="#038B47"/>
<path opacity="0.1" d="M105.089 5.31355C104.44 5.13604 103.794 5.14321 103.055 5.1514C102.87 5.15344 102.685 5.15549 102.501 5.15754C103.415 4.31625 104.329 3.47496 104.965 2.45206C105.146 2.173 104.774 1.90007 104.591 2.0868C103.492 2.93014 102.486 3.86479 101.48 4.79945C101.467 3.59904 101.454 2.39863 101.441 1.19822C101.434 0.644186 100.603 0.653401 100.609 1.20744C100.623 2.40784 100.637 3.70059 100.65 4.901C99.8096 4.07916 98.9701 3.34967 98.1307 2.62017C97.7581 2.34725 97.3014 2.81406 97.6739 3.08698C98.3287 3.81853 98.9834 4.55007 99.7306 5.2806C98.8069 5.29084 97.8832 5.30108 96.9606 5.40365C96.5911 5.40775 96.5973 5.96178 96.9667 5.95769C98.0762 6.03774 99.0922 6.02648 100.108 6.01521C99.2851 6.76314 98.463 7.60341 97.7333 8.44265C97.3679 8.81611 97.9272 9.27166 98.2936 8.99054C99.1168 8.24262 99.9409 7.58703 100.672 6.84012C100.683 7.85585 100.695 8.96392 100.891 9.97761C100.893 10.1623 101.263 10.1582 101.353 9.97249C101.528 9.04705 101.516 8.03132 101.505 7.01559C101.784 7.19719 101.972 7.47216 102.251 7.65377C102.81 8.10932 103.37 8.56487 103.928 8.92809C104.115 9.11072 104.389 8.83063 104.202 8.648C103.734 8.09908 103.358 7.54914 102.891 7.00023C102.609 6.63394 102.237 6.36102 101.957 6.08707C102.418 6.08196 102.788 6.07786 103.25 6.07274C103.989 6.06455 104.543 6.05841 105.28 5.86554C105.371 5.77217 105.367 5.40282 105.089 5.31355Z" fill="#030229"/>
<path opacity="0.1" d="M9.54456 51.9141C8.89594 51.7366 8.24937 51.7437 7.51043 51.7519C7.3257 51.754 7.14096 51.756 6.95623 51.7581C7.87069 50.9168 8.78515 50.0755 9.42046 49.0526C9.60213 48.7735 9.22959 48.5006 9.0469 48.6873C7.85431 49.4394 6.84953 50.4664 5.84372 51.401C5.83042 50.2006 5.81711 49.0002 5.8038 47.7998C5.79766 47.2457 4.96636 47.255 4.9725 47.809C4.9858 49.0094 5.00013 50.3022 5.01344 51.5026C4.17292 50.6807 3.33343 49.9512 2.49393 49.2217C2.12139 48.9488 1.66467 49.4156 2.03721 49.6885C2.69197 50.4201 3.34673 51.1516 4.09386 51.8822C3.17019 51.8924 2.24651 51.9026 1.32386 52.0052C0.954394 52.0093 0.960535 52.5633 1.33001 52.5592C2.43944 52.6393 3.45548 52.628 4.47152 52.6168C3.6484 53.3647 2.82631 54.205 2.09658 55.0442C1.73121 55.4177 2.29053 55.8732 2.65693 55.5921C3.48004 54.8442 4.30419 54.1886 5.03494 53.4417C5.0462 54.4574 5.05848 55.5655 5.25447 56.5792C5.25652 56.7638 5.62599 56.7597 5.71631 56.574C5.89081 55.6486 5.87955 54.6329 5.86829 53.6171C6.14744 53.7988 6.33525 54.0737 6.61439 54.2553C7.17372 54.7109 7.73304 55.1664 8.29134 55.5296C8.47812 55.7123 8.75215 55.4322 8.56537 55.2496C8.09739 54.7006 7.72178 54.1507 7.2538 53.6018C6.9726 53.2355 6.60006 52.9626 6.31989 52.6886C6.78173 52.6835 7.1512 52.6794 7.61303 52.6743C8.35197 52.6661 8.90618 52.66 9.64307 52.4671C9.73441 52.3737 9.73032 52.0044 9.54456 51.9141Z" fill="#030229"/>
<path d="M25.0922 21.3576C24.07 20.8148 23.1402 20.271 22.391 19.3558C21.5485 18.3493 21.1657 17.153 20.5982 15.9587C20.5982 15.9587 20.5971 15.8664 20.5048 15.8674L20.4124 15.8684C20.4124 15.8684 20.4124 15.8684 20.3211 15.9618C20.3211 15.9618 20.3211 15.9618 20.3221 16.0541C20.0726 18.5504 18.6142 20.3212 16.7842 21.9114C16.6929 22.0048 16.6949 22.1895 16.7883 22.2808C18.8307 23.1816 20.2438 25.6594 20.9129 27.6837C21.0073 27.8674 21.2844 27.8643 21.3747 27.6786C21.7309 26.4741 21.9957 25.363 22.63 24.2477C23.2643 23.1325 24.0864 22.2922 25.0953 21.6346C25.1866 21.5412 25.1846 21.3566 25.0922 21.3576Z" fill="#54B785"/>
<path d="M166.238 49.0578C165.216 48.5151 164.286 47.9713 163.629 47.055C162.787 46.0485 162.404 44.8522 161.836 43.6579C161.836 43.6579 161.835 43.5656 161.743 43.5666L161.651 43.5677C161.651 43.5677 161.651 43.5676 161.559 43.661C161.559 43.661 161.559 43.661 161.56 43.7534C161.311 46.2496 159.852 48.0204 158.023 49.6107C157.931 49.704 157.933 49.8887 158.027 49.98C160.069 50.8809 161.482 53.3587 162.151 55.383C162.246 55.5666 162.523 55.5635 162.613 55.3778C162.969 54.1733 163.234 53.0622 163.868 51.947C164.503 50.8317 165.325 49.9915 166.334 49.3338C166.334 49.3338 166.331 49.1491 166.238 49.0578Z" fill="#54B785"/>
<path d="M98.5515 26.3495C97.8085 25.9884 97.2502 25.6252 96.6888 24.9849C96.1264 24.2524 95.8401 23.4244 95.369 22.5984C95.369 22.5984 95.369 22.5984 95.2767 22.5995L95.1843 22.6005C95.1843 22.6005 95.1843 22.6005 95.1853 22.6928C95.02 24.4493 94.0173 25.661 92.7364 26.7834C92.6451 26.8768 92.6461 26.9691 92.7385 26.9681C94.2235 27.5981 95.1666 29.3423 95.6438 30.7222C95.6459 30.9069 95.923 30.9038 95.9209 30.7192C96.0965 29.8861 96.3644 29.0519 96.818 28.3081C97.2716 27.5643 97.8197 27.0041 98.5535 26.5342C98.6459 26.5332 98.6439 26.3485 98.5515 26.3495Z" fill="#54B785"/>
<path d="M74.9903 42.8155C73.69 42.1835 72.6668 41.5484 71.8232 40.4495C70.7928 39.168 70.3157 37.7881 69.6527 36.3178C69.6527 36.3178 69.6517 36.2255 69.5593 36.2265L69.467 36.2275C69.467 36.2275 69.3746 36.2285 69.3756 36.3209L69.3766 36.4132C69.0399 39.3722 67.3095 41.6078 65.1132 43.4791C65.0218 43.5725 65.0249 43.8495 65.2096 43.8475C67.7158 44.9279 69.4112 47.8643 70.1778 50.3493C70.2732 50.6253 70.6427 50.6212 70.732 50.3431C71.0861 48.9539 71.5326 47.5637 72.2572 46.2628C72.9818 44.9619 73.9866 43.9349 75.2715 43.1818C75.0868 43.1839 75.1761 42.9058 74.9903 42.8155Z" fill="#54B785"/>
<path d="M52.8392 19.5609C51.5256 17.7285 50.213 15.9883 48.534 14.5293C47.6022 13.8009 46.6703 13.0724 45.6481 12.5296C45.0909 12.2588 44.5346 12.0802 43.9773 11.8093C43.6992 11.7201 43.4211 11.6308 43.1419 11.4492C42.8638 11.3599 42.677 11.1773 42.4009 11.2727C42.2162 11.2748 42.1249 11.3681 42.2193 11.5518C42.3168 12.0125 42.874 12.2833 43.2466 12.5562C43.7125 12.9205 44.1774 13.1924 44.6433 13.5566C45.5742 14.1928 46.506 14.9212 47.3455 15.6507C48.9322 17.1107 50.2427 18.6662 51.4629 20.4073C52.0264 21.2322 53.4037 20.4781 52.8392 19.5609Z" fill="#FF8F6B"/>
<path d="M52.1804 56.6106C51.422 54.8644 49.6568 53.9604 47.8936 53.2412C46.1304 52.5219 44.0912 51.8981 42.2469 52.1956C40.494 52.3997 38.5665 53.5293 37.9384 55.1985C37.4899 56.4041 37.0475 58.1636 38.1661 59.0747C38.7265 59.6226 39.7435 59.7037 40.2916 59.1435C41.206 58.3022 40.3604 57.0187 39.6143 56.3805C36.5355 53.6441 31.368 54.1632 27.9678 55.7708C25.8536 56.7177 24.0237 58.308 22.9388 60.4441C22.0335 62.1164 21.0503 65.0825 22.2705 66.8237C22.4583 67.0986 22.8278 67.0945 23.0094 66.8155C24.0101 65.4191 23.9876 63.3877 24.7102 61.902C25.4317 60.3241 26.6181 59.018 27.9944 58.1716C30.8374 56.2931 35.7226 55.3154 38.7009 57.3141C39.0734 57.5871 40.0966 58.2222 39.5485 58.7823C39.0918 59.2492 38.3478 58.7957 38.0666 58.4294C36.9357 56.4102 39.5897 54.1644 41.2472 53.6842C42.9047 53.2041 44.8496 53.6443 46.427 54.2733C48.1881 54.8079 50.2314 55.8011 51.2639 57.2672C51.7277 57.4468 52.3702 57.0703 52.1804 56.6106Z" fill="#EF37FF"/>
<path d="M133.27 41.9431C133.362 41.9421 133.361 41.8498 133.268 41.8508C133.176 41.8518 133.177 41.9442 133.27 41.9431Z" fill="#3F3937"/>
<path d="M134.088 40.3627C135.626 37.3904 138.824 34.2151 142.438 35.2832C143.735 35.6382 145.411 36.8202 145.245 38.4844C145.165 39.5935 143.864 38.8691 143.397 38.4125C142.275 37.2244 142.806 35.0944 143.16 33.7053C143.693 31.8523 144.875 30.0846 146.433 28.9591C147.715 27.929 149.465 27.4479 151.033 27.2458C152.786 27.0417 154.362 27.5783 156.029 27.9292C156.676 28.0144 157.13 27.2706 156.663 26.814C155.448 25.5346 153.321 25.3734 151.661 25.5765C149.908 25.7807 148.066 26.2628 146.599 27.295C143.665 29.2668 141.494 33.4467 141.81 36.9525C142.012 38.5202 144.077 41.4525 145.814 39.771C146.637 39.023 146.344 37.641 145.965 36.7217C145.303 35.3438 143.815 34.4368 142.425 34.0828C138.256 33.0208 135.062 36.5655 133.531 40.0918C133.441 40.3699 133.906 40.6418 134.088 40.3627Z" fill="#EF37FF"/>
<path d="M54.1762 36.5495C52.8626 34.717 51.1846 33.3504 49.2346 32.4485C48.2135 31.998 47.1933 31.6399 46.1752 31.4665C45.2495 31.2921 43.863 31.2151 43.0368 31.686C42.8531 31.7804 42.8562 32.0574 43.0429 32.24C43.787 32.6936 44.8964 32.7736 45.7298 32.9491C46.7489 33.2148 47.5833 33.4826 48.5121 33.9341C50.2763 34.7457 51.9522 35.9277 53.1693 37.3918C53.6373 37.9407 54.6452 37.1907 54.1762 36.5495Z" fill="#FF8F6B"/>
<path d="M33.0943 42.9678C33.9236 42.7739 34.8462 42.6713 35.6775 42.6621C36.1394 42.657 36.6012 42.6518 37.0631 42.6467C37.3402 42.6437 37.6173 42.6406 37.801 42.5462C37.9847 42.4518 38.1694 42.4498 38.3531 42.3554C38.5368 42.261 38.5338 41.984 38.348 41.8937C38.1623 41.8034 37.9765 41.7131 37.8831 41.6218C37.6973 41.5315 37.3279 41.5356 37.1421 41.4453C36.6803 41.4504 36.2184 41.4555 35.6653 41.554C34.7426 41.6566 33.821 41.8515 32.9004 42.1388C32.3472 42.2372 32.5412 43.0662 33.0943 42.9678Z" fill="#FF8F6B"/>
<path d="M131.494 64.9554C134.062 63.357 136.819 62.0335 139.766 61.1697C141.147 60.785 142.621 60.3993 144.097 60.1982C144.927 60.0966 145.665 59.9961 146.495 59.8946C147.142 59.8874 147.788 59.8802 148.339 59.5971C148.523 59.5027 148.52 59.2257 148.334 59.1354C147.685 58.8655 147.039 58.965 146.3 58.9732C145.469 58.9824 144.731 59.083 143.9 59.0922C142.33 59.2019 140.763 59.4964 139.197 59.8831C136.065 60.6566 133.309 62.0724 130.745 64.1326C130.38 64.506 130.942 65.2386 131.494 64.9554Z" fill="#FF8F6B"/>
<path d="M126.364 60.6716C128.556 58.3385 131.402 56.737 134.155 55.1366C135.533 54.3825 137.001 53.5351 138.472 52.8723C139.299 52.4937 140.034 52.1162 140.769 51.7386C141.504 51.3611 142.333 51.1672 143.067 50.6973C143.251 50.6029 143.247 50.3259 142.969 50.2366C142.228 50.0601 141.4 50.3464 140.662 50.4469C139.74 50.5495 138.911 50.8357 138.084 51.2143C136.43 51.9714 134.776 52.8209 133.216 53.7617C130.187 55.4576 127.527 57.2417 125.434 60.0355C125.069 60.5013 125.907 61.0461 126.364 60.6716Z" fill="#FF8F6B"/>
<path d="M111.196 16.9737C111.101 16.6977 111.098 16.4207 111.001 16.0524C110.999 15.8677 110.906 15.7764 110.905 15.684C110.904 15.5917 110.903 15.4994 110.809 15.408C110.808 15.3157 110.716 15.3167 110.715 15.2244C110.622 15.1331 110.528 15.0418 110.436 15.0428C110.344 15.0438 110.252 15.1372 110.161 15.2305C110.162 15.3229 110.069 15.3239 110.071 15.4162C110.072 15.5086 110.073 15.6009 110.074 15.6932C110.076 15.8779 110.078 16.0626 110.172 16.2463C110.175 16.5233 110.271 16.7993 110.366 17.0753L110.365 16.9829L110.366 17.0753C110.367 17.1676 110.461 17.3513 110.555 17.4426C110.648 17.5339 110.834 17.6242 110.925 17.5308C111.018 17.5298 111.201 17.4354 111.2 17.3431C111.2 17.3431 111.198 17.1584 111.196 16.9737Z" fill="#030229"/>
<path d="M115.037 30.2313C115.103 27.8294 115.818 25.6974 116.625 23.4721C117.075 22.3589 117.525 21.338 118.068 20.3162C118.611 19.2943 119.156 18.4571 119.421 17.346C119.419 17.1613 119.231 16.8863 119.048 17.073C118.591 17.4475 118.317 17.7276 117.952 18.1934C117.68 18.6582 117.409 19.2153 117.137 19.68C116.596 20.7943 116.054 21.9085 115.605 23.114C114.798 25.3393 114.364 27.8376 114.298 30.2395C114.396 30.7001 115.042 30.693 115.037 30.2313Z" fill="#FF8F6B"/>
<path d="M122.807 14.6317C122.897 14.446 122.989 14.3527 123.079 14.167C123.079 14.167 123.08 14.2593 122.987 14.2603C122.987 14.2603 122.986 14.168 123.079 14.167L123.17 14.0736C123.262 13.9802 123.262 13.9802 123.353 13.8869C123.535 13.6078 123.81 13.42 123.991 13.141C124.173 12.8619 124.448 12.6742 124.63 12.3951C124.72 12.2094 124.904 12.115 124.994 11.9293C124.993 11.837 125.085 11.8359 125.084 11.7436C125.176 11.6502 125.175 11.5579 125.174 11.4656C125.264 11.2799 125.076 11.0049 124.799 11.008C124.707 11.009 124.614 11.01 124.43 11.0121C124.337 11.0131 124.338 11.1054 124.246 11.1064C124.246 11.1064 124.246 11.1064 124.153 11.1075C124.246 11.1064 124.246 11.1064 124.153 11.1075C123.969 11.1095 123.786 11.2962 123.602 11.3906C123.235 11.5794 122.961 11.8595 122.687 12.1396C122.413 12.4197 122.139 12.6998 121.958 13.0712C121.776 13.3502 121.503 13.7227 121.414 14.0007C121.233 14.2798 121.33 14.7404 121.702 14.921C122.257 15.0072 122.625 14.9108 122.807 14.6317Z" fill="#FF8F6B"/>
<path d="M119.766 31.9333C120.035 31.1915 120.397 30.5411 120.666 29.7993C120.935 29.0575 121.205 28.408 121.566 27.6652C121.929 27.0148 122.197 26.273 122.56 25.6225C122.922 24.972 123.469 24.3195 123.553 23.5798C123.55 23.3028 123.272 23.2135 123.087 23.2155C122.35 23.4084 121.99 24.2436 121.535 24.8027C120.988 25.4552 120.626 26.198 120.265 26.9408C119.904 27.6837 119.635 28.4254 119.367 29.2596C119.279 29.6299 119.098 30.0014 119.103 30.463C119.015 30.8334 119.02 31.2951 119.024 31.6645C118.937 32.1272 119.585 32.3047 119.766 31.9333Z" fill="#FF8F6B"/>
<path d="M124.825 21.8095C125.005 21.3458 125.278 20.9734 125.551 20.6009C125.914 20.0428 126.092 19.3944 126.456 18.9286C126.821 18.4628 127.28 18.273 127.738 17.8985C128.196 17.5241 128.654 17.1496 129.11 16.6828C130.847 15.0012 132.863 13.5012 134.974 12.2773C135.525 11.9941 136.076 11.711 136.627 11.4278C136.995 11.239 137.545 10.8635 137.263 10.4049C136.79 9.48664 134.956 10.7075 134.405 10.9907C132.294 12.2146 130.559 13.9885 128.636 15.5798C128.086 15.9553 127.629 16.4221 127.173 16.8889C126.716 17.3558 126.354 18.0062 125.897 18.473C125.44 18.9399 124.889 19.223 124.432 19.6898C124.067 20.0633 123.796 20.6204 123.618 21.1765C123.256 21.9193 124.373 22.6457 124.825 21.8095Z" fill="#FF8F6B"/>
<path opacity="0.5" d="M81.1016 27.1887C81.4628 26.4459 81.545 25.5215 81.4434 24.6914C81.4331 23.768 81.3305 22.8457 81.1366 22.0167C81.1345 21.832 80.7651 21.8361 80.7671 22.0208C80.684 22.8528 80.6932 23.6839 80.7034 24.6073C80.7116 25.346 80.7208 26.1771 80.4509 26.8265C80.2713 27.2902 80.9219 27.6524 81.1016 27.1887Z" fill="#EF37FF"/>
<g opacity="0.5">
<path d="M81.1555 15.1825C81.1462 14.3515 81.2294 13.5194 81.1288 12.7817C81.0273 11.9517 80.742 11.216 80.272 10.4824C80.1775 10.2988 79.8091 10.3952 79.9045 10.6712C80.2904 12.1446 80.3078 13.7143 80.3252 15.2841C80.2379 15.7468 81.1616 15.7366 81.1555 15.1825Z" fill="#EF37FF"/>
</g>
<path opacity="0.5" d="M76.9963 7.28742C76.8033 6.55076 76.5181 5.81512 76.1414 5.17284C75.9536 4.89787 75.8572 4.52954 75.6693 4.25457C75.4815 3.9796 75.2907 3.42761 74.9212 3.43171C74.7365 3.43375 74.5517 3.4358 74.4614 3.6215C74.2808 3.99291 74.562 4.35919 74.7508 4.7265C74.9386 5.00147 75.1274 5.36878 75.2229 5.64477C75.5995 6.28705 75.8838 6.93035 76.0757 7.57468C76.2665 8.12666 77.1871 7.83941 76.9963 7.28742Z" fill="#EF37FF"/>
<path opacity="0.5" d="M81.2359 5.94652C81.4124 5.20576 81.4956 4.37368 81.5787 3.54161C81.5746 3.17225 81.5695 2.71055 81.5654 2.3412C81.5613 1.97184 81.5562 1.51015 81.3674 1.14284C81.2719 0.866843 80.9025 0.870939 80.8132 1.14898C80.6325 1.52038 80.6377 1.98208 80.6418 2.35144C80.6458 2.72079 80.6499 3.09015 80.654 3.45951C80.6622 4.19822 80.578 4.93796 80.4939 5.67769C80.4959 5.86237 80.5914 6.13836 80.7761 6.13632C80.9629 6.31895 81.2389 6.22354 81.2359 5.94652Z" fill="#EF37FF"/>
<path opacity="0.5" d="M84.7742 8.58601C84.9487 7.66057 85.309 6.82542 85.7626 6.08159C86.2163 5.33776 86.8557 4.68422 87.4017 3.93936C87.492 3.75366 87.3966 3.47767 87.2129 3.57205C86.1999 3.86033 85.4702 4.69958 85.0176 5.53575C84.4726 6.37294 84.2067 7.39175 84.0322 8.31718C83.8536 8.87327 84.688 9.14107 84.7742 8.58601Z" fill="#EF37FF"/>
<path d="M145.868 44.8447C145.96 44.7513 145.959 44.6589 146.05 44.5656C146.14 44.3799 146.231 44.1942 146.228 44.0095C146.226 43.8248 146.225 43.7325 146.316 43.5468L146.315 43.4544C146.314 43.3621 146.313 43.2698 146.312 43.1774C146.31 42.9927 146.308 42.8081 146.213 42.6244C146.211 42.4397 146.118 42.3484 146.024 42.2571C145.835 41.8898 145.463 41.6169 145 41.5297C145.186 41.62 145.372 41.7102 145.558 41.8929C145.372 41.7102 145.186 41.6199 145.001 41.622C144.815 41.5317 144.631 41.5338 144.539 41.6271C144.355 41.6292 144.263 41.7225 144.079 41.8169C143.896 41.9113 143.713 42.098 143.623 42.2837C143.898 42.096 144.08 41.9093 144.356 41.7215C144.263 41.7225 144.172 41.8159 144.079 41.8169C143.896 41.9113 143.712 42.0057 143.621 42.0991C143.529 42.1924 143.438 42.2858 143.347 42.3791C143.348 42.4715 143.255 42.4725 143.256 42.5648C143.257 42.6572 143.166 42.7505 143.167 42.8429C143.258 42.7495 143.256 42.5648 143.348 42.4715C143.349 42.5638 143.256 42.5648 143.257 42.6572C143.258 42.7495 143.166 42.7505 143.167 42.8429C143.076 42.9362 143.078 43.1209 142.986 43.2143C142.896 43.4 142.806 43.5857 142.809 43.8627C142.719 44.0484 142.814 44.3244 142.816 44.5091C142.91 44.6927 143.005 44.8764 143.099 45.06C143.194 45.2437 143.38 45.4263 143.566 45.5166C143.66 45.6079 143.844 45.6059 143.938 45.6972C144.216 45.7865 144.585 45.7824 144.861 45.687C144.953 45.5936 145.137 45.5916 145.229 45.4982C145.596 45.3094 145.778 45.0304 145.868 44.8447Z" fill="#FF8F6B"/>
<path d="M142.182 12.8439C142.181 12.7516 142.089 12.7526 142.088 12.6603C141.995 12.569 141.901 12.4777 141.9 12.3853C141.9 12.3853 141.807 12.294 141.714 12.295C141.529 12.2047 141.528 12.1124 141.25 12.0231C141.157 12.0242 140.971 11.9339 140.879 11.9349C140.787 11.9359 140.602 11.938 140.602 11.938L140.326 12.0334C140.142 12.1278 140.051 12.2211 139.961 12.4068C139.869 12.5002 139.869 12.5002 139.87 12.5925C139.871 12.6849 139.779 12.6859 139.78 12.7782C139.69 12.9639 139.6 13.242 139.603 13.519C139.606 13.796 139.701 13.9797 139.796 14.2556C140.078 14.7143 140.543 14.9862 141.005 14.9811C141.467 14.9759 142.018 14.6928 142.198 14.229C142.288 14.0433 142.377 13.7653 142.374 13.4883C142.372 13.3036 142.278 13.1199 142.182 12.8439Z" fill="#FF8F6B"/>
<path d="M74.2347 24.6812C73.4681 22.1963 73.8079 19.5143 74.2421 17.0161C74.24 16.8314 74.0543 16.7411 73.9639 16.9268C73.0679 19.4302 72.8225 22.2958 73.5901 24.8731C73.5952 25.3348 74.3321 25.1419 74.2347 24.6812Z" fill="#030229"/>
</svg>

        </div>

        {/* Texts */}
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-2xl font-semibold text-[#101828] text-center">
            Admin successfully added!
          </h2>
          <p className="text-base text-[#667185] text-center">
            Their role and permissions have been updated.
          </p>
        </div>

        {/* Button */}
        <button onClick={handleChange} className="px-6 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-r from-[#038B47] to-[#00AED9]">
            Done
        </button>
      </div>
    </div>
</div>
  )
}      

        
        
      </div>
    </div>
  );
};

export default AddAdmin;
